export default class PopupController {
    constructor() {
        const elements = document.querySelectorAll(".js-popup");

        if (elements.length > 0) {
            this.preCheckSessionOnce(elements);

            import(/* webpackChunkName: "Popup" */ "../classes/Popup").then(res => {
                const Popup = res.default;
                // Luôn tạo instance để nút đóng / mở lại thủ công vẫn hoạt động
                // kể cả khi data-auto-show="false" (đã xem trong phiên).
                elements.forEach(element => {
                    this.createInstance(Popup, element);
                });
            });
        }
    }

    preCheckSessionOnce(elements) {
        elements.forEach(element => {
            const sessionOnce = element.dataset.sessionOnce === "true";
            if (!sessionOnce) {
                return;
            }

            const popupId = element.id;
            if (!popupId) {
                return;
            }

            // Cookie phiên dùng chung mọi tab (đọc sớm trước khi load chunk)
            const key = `dgv_popup_shown_${String(popupId).replace(/[^\w-]/g, "_")}`;
            const encoded = encodeURIComponent(key);
            let cookieHit = false;
            if (typeof document !== "undefined") {
                const match = document.cookie.match(new RegExp(`(?:^|; )${encoded}=([^;]*)`));
                cookieHit = !!(match && decodeURIComponent(match[1]) === "1");
            }

            let legacyHit = false;
            try {
                legacyHit = typeof sessionStorage !== "undefined"
                    && sessionStorage.getItem(`popup_shown_${popupId}`) === "true";
            } catch (e) {
                legacyHit = false;
            }

            if (cookieHit || legacyHit) {
                if (legacyHit && !cookieHit) {
                    document.cookie = `${encoded}=1; path=/; SameSite=Lax`;
                }
                element.style.display = "none";
                element.dataset.autoShow = "false";
            }
        });
    }

    createInstance(Popup, element) {
        return new Popup(element);
    }
}
